import { Modal, Table, Button, Spin } from "antd";
import "../../styles/Dashboard.css";
import newStyled from "@emotion/styled";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { useEffect } from "react";

const AllCycleModal = ({ open, selectedQueId, onClose }) => {
  const { loading: loading, data: data, getData: getData } = useFetchFunction();
  const navigate = useNavigate();

  useEffect(() => {
    if (!open || !selectedQueId) return;

    getData(
      `dashboard/questionnaire_type/${selectedQueId}/all_audit_cycle_scores`,
    );
  }, [open, selectedQueId]);

  const dataSource = data?.map((data, index) => ({
    key: data.audit_store_id,
    index: index + 1,
    ...data,
  }));

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "index",
      key: "Index",
      align: "center",
      width: "10%",
    },
    {
      title: "Cycle Name",
      dataIndex: "name",
      align: "center",
      width: "30%",
    },
    {
      title: "Total Score",
      dataIndex: "get_total_percentage",
      align: "center",
      width: "20%",
    },
    {
      title: "Conducted Audits",
      dataIndex: "get_total_audit_stores_count",
      align: "center",
      width: "20%",
    },
    {
      title: "Cycle Performance",
      align: "center",
      width: "20%",
      render: (_, record) => {
        return (
          <BtnStyle
            style={{
              fontSize: "1rem",
              padding: "8px",
              backgroundColor: "#007dc1",
              color: "#fff",
            }}
            onClick={() => {
              console.log("clicked", record?.id);

              navigate("/reportbrowser", {
                state: {
                  questionnaireTypeId: selectedQueId,
                  auditCycleId: record?.id,
                },
              });
            }}
          >
            <EyeOutlined /> View
          </BtnStyle>
        );
      },
    },
  ];

  return (
    <ModalStl
      title="All Cycle Scores"
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      styles={{
        body: {
          maxHeight: "75vh",
          overflowY: "auto",
        },
      }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <TableStyle
          dataSource={dataSource}
          columns={columns}
          rowKey={(record) => record.audit_store_id}
          pagination={false}
          bordered={true}
          rowClassName={() => "custom-row"}
        />
      )}
    </ModalStl>
  );
};

const TableStyle = newStyled(Table)`
.centered-column {
    text-align: center !important; 
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper table {
    width: 100%;
    text-align: start;
    border-radius: 8px 8px 0 0;
    border-spacing: 0;
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead > tr > th,
 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-tbody > tr > td {
    border: 1px solid #dde1e6 !important;
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>th, :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>td {
    color: #000 !important;
     font-size:1.1rem !important;
   font-family:'Roboto', sans-serif !important;
    background: rgb(242,242,242) !important;
  }

`;

const ModalStl = newStyled(Modal)`
:where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-title {
color: #003C5D !important;
font-size:1.5rem !important;
font-family:'Roboto', sans-serif !important;
}
`;

const BtnStyle = newStyled(Button)`
:where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid{
 background-color: #007dc1 !important;
}
`;
export default AllCycleModal;
